import {Badge} from "@/components/ui/badge";
import {cn} from "@/lib/utils";
import {useTranslation} from "react-i18next";

import {tShiftStatusLabel} from "../lib/shift-status-i18n";
import {Shift} from "../types";

interface StatusBadge {
  shift: Shift;
}

export const STATUS_MAP = {
  unscheduled: "unpublish",
  scheduled: "published",
};

const STATUS_BADGE_VARIANTS = {
  unscheduled: "warning",
  scheduled: "secondary",
  active: "info",
  completed: "success",
  cancelled: "error",
  no_show: "danger",
} as const;

export function StatusBadge({shift}: StatusBadge) {
  const {t} = useTranslation("shifts");
  const statusText = tShiftStatusLabel(shift.status, t);
  const variant = STATUS_BADGE_VARIANTS[shift.status as keyof typeof STATUS_BADGE_VARIANTS];
  return (
    <Badge variant={variant} className={cn("capitalize")}>
      {statusText}
    </Badge>
  );
}
